export const GOOGLE_PLAY_STORE_LINK =
  'https://play.google.com/store/apps/details?&id=cz.studybuddy.studybuddy&referrer=utm_source%3Dstudybuddy.cz';
